import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// AuthGuard prevents authenticated users from accessing login page
function AuthGuard({ children }) {
  const { isAuthenticated, getUserRole, loading } = useAuth();

  // Show loading state while checking auth
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (isAuthenticated()) {
    const userRole = getUserRole();
    console.log("AuthGuard: User is authenticated with role:", userRole);

    // Redirect to appropriate dashboard based on role
    if (userRole === "admin" || userRole === "admin_team") {
      return <Navigate to="/dashboard" replace />;
    } else if (userRole === "investor") {
      return <Navigate to="/investor-dashboard" replace />;
    } else {
      // Unknown role, clear token and show login
      localStorage.removeItem("token");
      return children;
    }
  }
  return children;
}

export default AuthGuard;
